
import { CircularProgress } from '@mui/material';
import React from 'react'

const loaderStyle = {
    display: 'flex',
    justifyContent: 'center', /* Centers horizontally */
    alignItems: 'center',
    top: '0%',
    left: '0%',
    height: '100%',
    width: '100%',
    backgroundColor: 'rgb(0, 0, 0,0.5)',
    position: 'fixed',
    zIndex: '999999'

}

const messageStyle = {
    fontWeight: 'bold',
    color: '#002266'
}

const Loader = ({ message, heightOfLoader, marginTopLoader }) => {
    return (
        <div className="loader_background" style={loaderStyle}>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <CircularProgress size="4rem" />
                <span style={messageStyle}>{message}Loading....</span>
            </div>

        </div>

    )
}
export default Loader;


